<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'gestoesDeAulas',
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Plano Bimestral
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="primary" outlined>
          <v-card-text>
            <h4 style="color: white">Turma: {{ gestaoDeAula.turma.descricao }}</h4>
            <h4 style="color: white">
              Disciplina:
              {{
                !gestaoDeAula.is_polivalencia == 1
                  ? gestaoDeAula.disciplina.descricao
                  : gestaoDeAula.disciplina
              }}
            </h4>
            <h4 style="color: white">
              Professor:
              {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[carregando...]" }}
            </h4>
          </v-card-text>
          <v-col cols="12">
            <v-btn
              x-small
              class="ml-1 white--text"
              color="teal darken-2"
              @click="() => verHistoricoPlanos()"
            >
              <span>Histórico do lançamento de planos</span>
            </v-btn>
          </v-col>
        </v-card>
      </v-col>
      <v-col cols="12 text-center" class="pt-2">
        <template>
          <v-toolbar>
            <v-tabs dark v-model="form.bimestre" background-color="primary" grow>
              <v-tab
                v-for="item of $constants.bimestres"
                :key="item.value"
                @click="() => editarPlano(item.value ? item.value : 0)"
              >
                <v-badge v-if="form.bimestre === item.value" color="success">
                  {{ item.desc }}
                </v-badge>
                <div v-else>{{ item.desc }}</div>
              </v-tab>
            </v-tabs>
          </v-toolbar>
        </template>
      </v-col>
    </v-row>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form
        @submit.prevent="handleSubmit(createOrUpdate)"
        :disabled="submittingForm"
        v-if="loadPlano"
      >
        <v-row>
          <!-- <v-col cols="12">
            <ValidationProvider name="Tematica" rules="required" v-slot="{ errors }">
              <e-label>UNIDADES TEMÁTICAS / PRÁTICAS DE LINGUAGEM</e-label>
              <v-textarea solo dense v-model="form.tematica" :error-messages="errors" />
            </ValidationProvider>
          </v-col> -->
          <v-col cols="12">
            <ValidationProvider
              name="Competência gerais"
              :rules="{ required: true, max_chars: 4000, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>COMPETÊNCIAS GERAIS (BNCC)</e-label>
              <v-textarea
                solo
                dense
                v-model="form.competencias_gerais"
                :error-messages="errors"
                counter
                maxlength="4000"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider
              name="Habilidades Geral"
              :rules="{ required: true, max_chars: 4000, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>HABILIDADES GERAL</e-label>
              <v-textarea
                solo
                dense
                v-model="form.habilidades"
                :error-messages="errors"
                counter
                maxlength="4000"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider
              name="Objeto de conhecimento"
              :rules="{ required: true, max_chars: 4000, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>OBJETO DE CONHECIMENTO</e-label>
              <v-textarea
                solo
                dense
                v-model="form.objeto_conhecimento"
                :error-messages="errors"
                counter
                maxlength="4000"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider
              name="Competência específica da área"
              :rules="{ required: true, max_chars: 4000, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>COMPETÊNCIA ESPECÍFICA DA ÁREA</e-label>
              <v-textarea
                solo
                dense
                v-model="form.competencias_especificas_area"
                :error-messages="errors"
                counter
                maxlength="4000"
              />
            </ValidationProvider>
          </v-col>
          <!-- <v-col cols="12">
            <ValidationProvider name="ABORDAGEM PEDAGÓGICA" rules="required" v-slot="{ errors }">
              <e-label>ABORDAGEM PEDAGÓGICA</e-label>
              <v-textarea solo dense v-model="form.abordagem_pedagogica" :error-messages="errors" />
            </ValidationProvider>
          </v-col> -->
          <v-col cols="12">
            <ValidationProvider
              name="Estrategia de ensino"
              :rules="{ required: true, max_chars: 4000, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>ESTRATÉGIA DE ENSINO</e-label>
              <v-textarea
                solo
                dense
                v-model="form.estrategia_ensino"
                :error-messages="errors"
                counter
                maxlength="4000"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider
              name="Recursos didaticos"
              :rules="{ required: true, max_chars: 4000, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>RECURSOS DIDÁTICOS</e-label>
              <v-textarea
                solo
                dense
                v-model="form.recursos_didaticos"
                :error-messages="errors"
                counter
                maxlength="4000"
              />
            </ValidationProvider>
          </v-col>
          <!-- <v-col cols="12">
            <ValidationProvider name="PROCESSOS AVALIATIVOS" rules="required" v-slot="{ errors }">
              <e-label>PROCESSOS AVALIATIVOS</e-label>
              <v-textarea
                solo
                dense
                v-model="form.avaliacao_aprendizagem"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col> -->
          <v-col cols="12">
            <ValidationProvider
              name="Avaliação de aprendizagem"
              :rules="{ required: true, max_chars: 4000, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>AVALIAÇÃO DE APRENDIZAGEM</e-label>
              <v-textarea
                solo
                dense
                v-model="form.avaliacao_aprendizagem"
                :error-messages="errors"
                counter
                maxlength="4000"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider
              name="Referencia"
              :rules="{ required: true, max_chars: 4000, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>REFERÊNCIAS</e-label>
              <v-textarea
                solo
                dense
                v-model="form.referencias"
                :error-messages="errors"
                counter
                maxlength="4000"
              />
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-col cols="12">
          <v-row>
            <v-btn
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              >Enviar Dados</v-btn
            >
            <v-btn color="success" class="ml-3" @click="dialog = true">Exportar plano</v-btn>
          </v-row>
        </v-col>
      </form>
    </ValidationObserver>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="800px">
        <v-card>
          <v-card-title class="primary">
            <span style="color: #fff" class="text-h5">Exportar Plano</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <ValidationObserver v-slot="{ handleSubmit }">
                <form @submit.prevent="handleSubmit(exportarPlano)" :disabled="submittingForm">
                  <v-row>
                    <v-col class="pt-4 pb-0" cols="12">
                      <e-label class="font-weight-medium">Turma</e-label>
                      <p class="font-weight-regular">
                        <v-select
                          :items="turmas"
                          item-text="turma.descricao"
                          item-value="turma.id"
                          return-object
                          label="Selecione o campo abaixo"
                          v-model="turmaSelecionada"
                          @change="(item) => setGestao(item)"
                        ></v-select>
                      </p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <e-label class="font-weight-medium">COMPETÊNCIAS GERAIS (BNCC)</e-label>
                      <p class="font-weight-regular">
                        {{ form.competencias_gerais }}
                      </p>
                    </v-col>
                    <v-col cols="12">
                      <e-label class="font-weight-medium">HABILIDADES GERAL</e-label>
                      <p class="font-weight-regular">
                        {{ form.habilidades }}
                      </p>
                    </v-col>
                    <v-col cols="12">
                      <e-label class="font-weight-medium">OBJETO DE CONHECIMENTO</e-label>
                      <p class="font-weight-regular">
                        {{ form.objeto_conhecimento }}
                      </p>
                    </v-col>
                    <v-col cols="12">
                      <e-label class="font-weight-medium">COMPETÊNCIA ESPECÍFICA DA ÁREA</e-label>
                      <p class="font-weight-regular">
                        {{ form.competencias_especificas_area }}
                      </p>
                    </v-col>
                    <v-col cols="12">
                      <e-label class="font-weight-medium">ESTRATÉGIA DE ENSINO</e-label>
                      <p class="font-weight-regular">
                        {{ form.estrategia_ensino }}
                      </p>
                    </v-col>
                    <v-col cols="12">
                      <e-label class="font-weight-medium">RECURSOS DIDÁTICOS</e-label>
                      <p class="font-weight-regular">
                        {{ form.recursos_didaticos }}
                      </p>
                    </v-col>
                    <v-col cols="12">
                      <e-label class="font-weight-medium">AVALIAÇÃO DE APRENDIZAGEM</e-label>
                      <p class="font-weight-regular">
                        {{ form.avaliacao_aprendizagem }}
                      </p>
                    </v-col>
                    <v-col cols="12">
                      <e-label class="font-weight-medium">REFERÊNCIAS</e-label>
                      <p class="font-weight-regular">
                        {{ form.referencias }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn style="color: #fff" class="red darken-1" @click="dialog = false">
                      Fechar
                    </v-btn>
                    <v-btn
                      :disabled="submittingForm"
                      :loading="submittingForm"
                      type="submit"
                      style="color: #fff"
                      class="green darken-1"
                      >Salvar</v-btn
                    >
                  </v-card-actions>
                </form>
              </ValidationObserver>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <e-modal-confirm
        :confirmDialog="confirmDialog"
        :objectModal="objectModal"
        @changeModalConfirm="enableSubmit"
      >
      </e-modal-confirm>
    </v-row>
    <e-drawer-planos-lancados
      v-model="openDrawer"
      :gestao_id="parseInt($route.params.gestaoDeAulaId, 10)"
      :disciplina_id="parseInt($route.params.disciplinaId, 10)"
      :bimestre="parseInt(form.bimestre, 10)"
    />
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    gestaoDeAulaId: {
      type: [String, Number],
      require: true,
    },
  },

  mounted() {
    this.loadData();
  },

  data() {
    return {
      loadPlano: true,
      enableSubmit: true,
      dialog: false,
      confirmDialog: false,
      turmas: [],
      submittingForm: false,
      turmaSelecionada: {
        turma: {
          id: null,
          franquia: {
            descricao: "",
            fantasia: "",
          },
        },
      },
      objectModal: {
        title: "Exportar plano",
        message: "Tem certeza que deseja exportar esta plano?",
      },
      form: {
        bimestre: 0,
      },
      formExportarPlano: {
        bimestre: 0,
      },
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
      export_gestao: null,
      disciplinas: [],
      openDrawer: false,
    };
  },
  methods: {
    async editarPlano(bimestre) {
      this.loadPlano = true;
      this.$loaderService.open("Carregando dados...");
      try {
        const { gestaoDeAulaId } = this.$route.params;
        this.form.instrutorDisciplinaTurma_id = gestaoDeAulaId;
        this.form.disciplina_id = this.disciplinaId;
        // await this.$services.planosBimestraisService.createOrUpdate(this.form);
        const response = await this.$services.planosBimestraisService.planoBimestral(
          gestaoDeAulaId,
          bimestre,
          this.disciplinaId
        );
        if (response !== "") {
          this.form = response;
          return;
        }
        this.form = {
          bimestre,
        };
        this.loadPlano = true;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async verHistoricoPlanos() {
      this.openDrawer = !this.openDrawer;
    },

    setGestao(item) {
      this.export_gestao = item.id;
    },

    async createOrUpdate() {
      this.$loaderService.open("Carregando dados...");
      try {
        const { gestaoDeAulaId } = this.$route.params;
        const { bimestre } = this.form;
        this.form.instrutorDisciplinaTurma_id = gestaoDeAulaId;
        this.form.bimestre = bimestre;
        this.form.disciplina_id = this.disciplinaId;
        await this.$services.planosBimestraisService.createOrUpdate(this.form);
        this.$toast.success("Plano bimestral salvo com sucesso!");
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async exportarPlano() {
      this.$loaderService.open("Exportando plano...");
      try {
        // const { gestaoDeAulaId } = this.$route.params;
        const { bimestre } = this.form;

        this.formExportarPlano.instrutorDisciplinaTurma_id = this.export_gestao;
        this.formExportarPlano.bimestre = bimestre;
        // this.formExportarPlano.tematica = this.form.tematica;
        this.formExportarPlano.competencias_gerais = this.form.competencias_gerais;
        this.formExportarPlano.habilidades = this.form.habilidades;
        this.formExportarPlano.objeto_conhecimento = this.form.objeto_conhecimento;
        this.formExportarPlano.avaliacao_aprendizagem = this.form.avaliacao_aprendizagem;
        this.formExportarPlano.competencias_especificas_area =
          this.form.competencias_especificas_area;
        this.formExportarPlano.estrategia_ensino = this.form.estrategia_ensino;
        this.formExportarPlano.recursos_didaticos = this.form.recursos_didaticos;
        this.formExportarPlano.referencias = this.form.referencias;
        this.formExportarPlano.ods = this.form.ods;
        this.formExportarPlano.metodologia = this.form.metodologia;
        this.formExportarPlano.disciplina_id = this.disciplinaId;

        // this.formExportarPlano.id = this.form.id;

        await this.$services.planosBimestraisService.createOrUpdate(this.formExportarPlano);

        this.$toast.success("Plano bimestral exportado com sucesso!");

        this.dialog = false;
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async loadData() {
      const { gestaoDeAulaId } = this.$route.params;
      this.disciplinaId = parseInt(this.$route.params.disciplinaId, 10);
      const { bimestre } = this.form;

      try {
        this.$loaderService.open("Carregando dados...");
        this.gestaoDeAula = await this.$services.gestoesDeAulasService.visualizar(gestaoDeAulaId);
        const gestoes = await this.$services.gestoesDeAulasService.listarGestoesProfessor(
          this.gestaoDeAula
        );
        this.turmas = gestoes;

        const response = await this.$services.planosBimestraisService.planoBimestral(
          gestaoDeAulaId,
          bimestre,
          this.disciplinaId
        );

        if (this.gestaoDeAula.disciplinas.length > 0) {
          const disciplina = this.gestaoDeAula.disciplinas.filter((i) => {
            return i.id === this.disciplinaId;
          });

          this.gestaoDeAula.disciplina = disciplina[0].descricao;
        }

        if (response !== "") {
          this.form = response;
        }
        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
  },
};
</script>

<style></style>
